import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('moveCursorAtEnd');

const moveCursorAtEnd = (element) => {
  if (!element) {
    return element;
  }

  if (isNotFn(element.setSelectionRange)) {
    L.warn('The input element:', element, 'has no valid setSelectionRange function');
    return element;
  }

  const end = fromAnyToString(element.value).length;
  element.setSelectionRange(end, end);

  return element;
};

// noinspection JSUnusedGlobalSymbols
export default moveCursorAtEnd;
